import config from 'Cloud/config';
import { addPromoToShowQueue } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendGa } from 'reactApp/utils/ga';
import { sendConfigPixel } from 'reactApp/utils/sendPixel';
import { put, select } from 'redux-saga/effects';

export type TTopBannerConfig = {
    id?: string;
    banner_id: string;
    banner_height?: string;
    html_content?: string;
    close_color: string;
    show_pixel?: string;
    click_pixel?: string;
    close_pixel?: string;
};

const PROMO_TOP_BANNER_CONFIG = config.get('PROMO_TOP_BANNER') as TTopBannerConfig | undefined;

const BANNER_ID = PROMO_TOP_BANNER_CONFIG?.id || PROMO_TOP_BANNER_CONFIG?.banner_id;
const banner = PROMO_TOP_BANNER_CONFIG?.html_content ? BANNER_ID : null;

let hasShow = false;
let hasClick = false;

const sendPromoGa = (action: string): void => {
    sendGa('promo-top-banner', action, BANNER_ID);
};

const onBannerClose = () => {
    sendConfigPixel(PROMO_TOP_BANNER_CONFIG, 'close_pixel');
    sendPromoGa('close');
};

const onBannerClick = () => {
    if (hasClick) {
        return;
    }
    hasClick = true;
    sendConfigPixel(PROMO_TOP_BANNER_CONFIG, 'click_pixel');
    sendPromoGa('click');
};

const onBannerShow = () => {
    if (hasShow) {
        return;
    }
    hasShow = true;
    sendConfigPixel(PROMO_TOP_BANNER_CONFIG, 'show_pixel');
    sendPromoGa('show');
};

export function* initTopBanner(priority: number) {
    if (!banner) {
        return;
    }

    const isNewbie = yield select(UserSelectors.isNewbie);
    const isB2B = yield select(UserSelectors.isB2BUser);
    const isOverQuota = yield select(UserSelectors.isOverQuotaUser);

    if (isNewbie || isOverQuota || isB2B || !PROMO_TOP_BANNER_CONFIG) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            priority,
            type: EPromoType.topBanner,
            data: {
                onShow: onBannerShow,
                onClose: onBannerClose,
                onClick: onBannerClick,
                html: PROMO_TOP_BANNER_CONFIG.html_content,
                closeColor: PROMO_TOP_BANNER_CONFIG.close_color,
                height: PROMO_TOP_BANNER_CONFIG.banner_height ? Number(PROMO_TOP_BANNER_CONFIG.banner_height) : undefined,
                promoId: BANNER_ID || '',
            },
        })
    );
}
